import { render, staticRenderFns } from "./_base-card-collapse.vue?vue&type=template&id=eaf0e68e&scoped=true&"
import script from "./_base-card-collapse.vue?vue&type=script&lang=js&"
export * from "./_base-card-collapse.vue?vue&type=script&lang=js&"
import style0 from "./_base-card-collapse.vue?vue&type=style&index=0&id=eaf0e68e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf0e68e",
  null
  
)

export default component.exports